import Highlight, { defaultProps } from "prism-react-renderer";
import React, { isValidElement } from "react";
import github from "prism-react-renderer/themes/github";

export const CodeHighlight = (props: JSX.IntrinsicElements["pre"]) => {
  if (!isValidElement(props.children)) {
    console.warn("children is not a valid element");
    return null;
  }

  const { children, className } = props.children.props;
  return (
    <Highlight
      {...defaultProps}
      theme={github}
      code={children}
      language={className?.replace(/^language-/, "")}
    >
      {({ className, style, tokens, getLineProps, getTokenProps }) => (
        <pre className={className} style={style}>
          {tokens.map((line, i) => (
            <div {...getLineProps({ line })} key={i}>
              {line.map((token, key) => (
                <span {...getTokenProps({ token })} key={key} />
              ))}
            </div>
          ))}
        </pre>
      )}
    </Highlight>
  );
};
